import { LitElement, nothing } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { defineZenComponent } from './register';

export class ZenSubtaskRow extends LitElement {
  static properties = {
    markup: { attribute: false },
  };

  declare markup: string;

  constructor() {
    super();
    this.markup = '';
  }

  createRenderRoot() {
    return this;
  }

  connectedCallback() {
    super.connectedCallback();
    this.style.display = 'contents';
  }

  render() {
    // Legacy escape hatch: this component still receives prebuilt markup from goals.ts string paths.
    // Kept intentionally in issue #623 until subtask rendering is fully data-driven.
    return this.markup ? unsafeHTML(this.markup) : nothing;
  }
}

defineZenComponent('zen-subtask-row', ZenSubtaskRow);
